import { memo } from 'react'
import Heading from '../../../../LuxKit/Typography/Heading'
import { INTL_SHORT_MONTH_LONG_YEAR } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'

interface Props {
  currentDate: Date
}

function VerticalDatePickerHeader(props: Props) {
  const {
    currentDate,
  } = props

  const formatDate = useIntlDateFormatter()
  const monthLabel = formatDate(currentDate, INTL_SHORT_MONTH_LONG_YEAR)

  return (
    <Heading variant="heading5">{monthLabel}</Heading>
  )
}

export default memo(VerticalDatePickerHeader)
